// @flow
import React, { useEffect, useState } from "react";
import "./piano.css";
import { Icon, IconClose } from '../../../base/icons';
import { connect } from "../../../base/redux/functions";
import { FEATURE_CUSTOM_REDUX } from "../../constant";

import keyboardShortcut from '../../../../../modules/keyboardshortcut/keyboardshortcut';
import { getBaseConfig } from "../../Utils.js";
import { getLJsonStorage } from "../../welcome-dashboard/Utils";
import { i18next } from "../../../base/i18n/index";

// import PianoIndex from "./components";




const Piano = (props) => {
  const { socket, Sessions, closeTool } = props;
  const { openByUser, SessionId } = Sessions;

  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    const { decodedData, secondModerator } = props;


    if (SessionId === openByUser) {
      setIsDisable(false);
    }

    if (!decodedData || secondModerator || decodedData?.gm) {
      setIsDisable(false);
    } else if (decodedData.student) {
      setIsDisable(true);
    }

    return () => {
      socket.off('played_note_return');
    };
  }, [openByUser]);


  useEffect(() => {

    keyboardShortcut.enable(false);
    return () => {
      keyboardShortcut.enable(true);

    }
  }, [])

  const { room_name } = props;

  //UPDATE TO LIVE:
  // let src = Constant.App.PianoUrl + "/?room_name=" + room_name + "&hasWeb=true&color=" + getBaseConfig("themePrimaryColor");
  let src = getBaseConfig("pianoUrl") + "/?room_name=" + room_name + "&hasWeb=true&color=" + getBaseConfig("themePrimaryColor");

  if (props?.isManualOpen == true) {
    src = src + "&isUserAllow=true"
  }

  let currentLanguage: string = i18next.language;

  if (currentLanguage) {
    src = src + "&_lang=" + currentLanguage
  }

  const isGuestAccount = getLJsonStorage("auth", "guest_id");

  return (

    // <div className='tool-layer'>
    // {/* if disable piano to play for student */}
    // {/* { 
    //   isDisable && <div className='piano-over-lay'></div>
    // } */}


    <div className="piano-container" id="piano-container" data-type={isDisable ? 1 : 0}>
      {(isDisable || isGuestAccount) ? '' :
        <div
          id="piano-close-icon-wrapper"
          className='close-side-bar'
          onClick={closeTool}>
          <Icon src={IconClose} containerId="piano-close-icon" />
        </div>
      }
      {/* <Keyboard
          socket={socket}
          Sessions={Sessions}
        /> */}
      <iframe id="piano-iframe" src={src} style={{ height: "244px", width: "100%", border: "none" }}>
      </iframe>

      {/* <PianoIndex
          {...props}
        ></PianoIndex> */}


    </div>
    // </div>
  )
}

const mapStateToProps = (state) => {
  return {
    room_name: state[FEATURE_CUSTOM_REDUX].roomorIpAddress
  }
}

export default connect(mapStateToProps)(Piano);
